import React from 'react'

export default function PageTitle({ title }: { title: string }) {
  return (
    <h1>{title}</h1>
  )
}
